// extracted by mini-css-extract-plugin
export default {"center":"InstallationChecklistPage_center__RFX5A"};